import { Skeleton } from "@mui/material";

interface SkeletonWrapperProps {
  loading: boolean;
}

export const SkeletonWrapper: React.FC<SkeletonWrapperProps> = ({
  loading,
}) => {
  if (!loading) return null;

  return (
    <div style={{ marginTop: 20, paddingLeft: 35, paddingRight: 25 }}>
      <Skeleton
        variant="rectangular"
        width="100%"
        height={150}
        data-testid="Skeleton"
      />
      <br />
      <br />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <div style={{ width: "48%" }}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={150}
            data-testid="Skeleton"
          />
          <br />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={225}
            data-testid="Skeleton"
          />
        </div>
        <div style={{ width: "48%" }}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={400}
            data-testid="Skeleton"
          />
        </div>
      </div>
    </div>
  );
};
